import { Tooltip, Avatar } from "@mantine/core";
import { extractInitialsFromText } from "@/utils/text";

const DEFAULT_MAX_VISIBLE = 3;
// prettier-ignore
const AvatarsColaboradores = ({
  colaboradores,
  maxVisible = DEFAULT_MAX_VISIBLE
}: {
  colaboradores: TColaborador[];
  maxVisible?: number;
}) => {
  // Deduplica colaboradores baseado no ID
  const uniqueColaboradores = colaboradores.filter((colaborador, index, array) => 
    array.findIndex(c => c.id === colaborador.id) === index
  );
  
  const firstsColaboradores = uniqueColaboradores.slice(0, maxVisible);
  const remainingColaboradores = uniqueColaboradores.slice(maxVisible);

  return (
    <Tooltip.Group openDelay={300} closeDelay={100}>
      <Avatar.Group>
        {firstsColaboradores.map((participante, index) => (
          <Tooltip label={participante.nome || participante.email} withArrow key={`${participante.id}-${index}`}>
            <Avatar 
              src={participante && participante.image && participante?.image[0]?.path || ""} 
              alt={participante.nome || participante.email}
            >
              {extractInitialsFromText(participante.nome || participante.email)}
            </Avatar>
          </Tooltip>
        ))}
        {remainingColaboradores.length > 0 && <Avatar>+{remainingColaboradores.length}</Avatar>}
      </Avatar.Group>
    </Tooltip.Group>
  );
};

export default AvatarsColaboradores;
